import React from "react";
import ModuleSwitcher from "./ModuleSwitcher";

export default function CompaniesModuleSwitcher({ current }) {
  return (
    <ModuleSwitcher
      current={current}
      primaryAccess="bre.companies"
      secondaryAccess="prospecting.companies"
      primaryValue="bre"
      secondaryValue="prospects"
      primaryLabel="BR&E Companies"
      secondaryLabel="Prospect Companies"
      primaryRoute="/bre-companies"
      secondaryRoute="/prospecting-companies"
      singleLabel={({ canSeePrimary }) =>
        canSeePrimary ? "BR&E Companies" : "Prospect Companies"
      }
      selectPadding="6px 44px 6px 28px"
    />
  );
}
